<template>
  <div class="app-container">
    <div class="gap">
      <span>我的等级： {{ score/10 <0 ?" 0":score/10 }} 级</span>
        <el-button type="primary"
                   size="mini"
                   @click="logout">退出</el-button>
   
  </div>
    <div class="gap">
      <el-form ref="queryForm"
             :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="求助状态"
                    prop="state">
                    <el-select v-model="queryParams.state" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </el-form-item>
      <el-form-item label="评价状态"
                    prop="judge">
                    <el-select v-model="queryParams.judge" placeholder="请选择">
    <el-option
      v-for="item in options1"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   :loading="loading"
                   size="mini"
                   @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
   
  </div>
    <el-table v-loading="loading"
              :data="list">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <!-- <el-table-column label="日志编号" align="center" prop="operId" /> -->
      <!-- <el-table-column label="产品图片"
                       align="center"
                       prop="img">
         <template slot-scope="scope">
          <img style="width:100px"
               :src="scope.row.img"
               alt="" />
        </template>
      </el-table-column> -->
      <el-table-column label="求助内容"
                       align="center"
                       prop="content" />
      <el-table-column label="所在地区"
                       align="center"
                       prop="address" />
      <el-table-column label="联系方式"
                       align="center"
                       prop="phone" />
      <el-table-column label="状态"
                       align="center"
                       :formatter="transType"
                       prop="state" />
      <el-table-column label="评价"
                       align="center"
                       :formatter="transJudge"
                       prop="judge" />
      <el-table-column label="评价内容"
                       align="center"
                       prop="judge_content" />

        <!-- <el-table-column label="数量"
                       align="center"
                       prop="num" />
      <el-table-column label="类型"
                       align="center"
                       prop="type"
                       :formatter="transType"> -->

      <!-- </el-table-column> -->

      <!-- <el-table-column label="操作地点" align="center" prop="operLocation" :show-overflow-tooltip="true" /> -->
      <el-table-column label="发布日期"
                       align="center"
                       prop="create_time"
                       width="180">
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="handleJudge(scope.row)">评价</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-updata"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click = 'getList'
      @next-click="getList"
    />

    <!-- 操作日志详细 -->
    <el-dialog title="详情"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="700px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助内容">
              <el-input v-model="form.content"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地区">
              <el-input v-model="form.address"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>


        <!-- 操作日志详细 -->
        <el-dialog title="评价"
               :visible.sync="judgeOpen"
               :close-on-click-modal="false"
               width="500px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="求助内容">
              <el-switch
  style="display: block"
  v-model="judge"
  active-color="#13ce66"
  inactive-color="#ff4949"
  active-text="好评"
  inactive-text="差评">
</el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评价内容">
              <el-input v-model="form.judge_content"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="judgeSubmit">确定</el-button>
        <el-button @click="judgeOpen = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { infoAdd,infoList,updateInfo,deleteInfo,judge,tongji,getProdList, getProdetail, addProduct, deleletProdcut, updateProduct } from '../api/productManage/index'
export default {
  name: 'Operlog',
  data () {
    return {
      value:'0',  //   求助状态
      options: [{
          value: '0',
          label: '求助中'
        }, {
          value: '1',
          label: '已解决'
        }],
      value1:'0',  //   求助状态
      options1: [
        {
          value: '0',
          label: '未评价'
        }, {
          value: '1',
          label: '好评'
        }, {
          value: '2',
          label: '差评'
        }
      ],
      score:'0',
      judge: true,
      pageIndex:1,
      pageSize:10,
      // 禁用状态
      disabled: false,
      queryParams: {
        state:'0',
        judge:'0'
      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total:0,
      // dialog 弹框
      open: false,
      judgeOpen:false,
      // 弹框 表单
      form: {}
    }
  },
  created () {
    this.handleQuery();
    this.score = localStorage.getItem('score')
    console.log(this.score)
  },
  methods: {
    //  退出
    logout(){
      localStorage.clear();
      this.$router.push('/')
    },
    // 翻译求助状态
    transType (row) {
      return row.state == '1' ? '已解决' :'求助中'
    },
    // 翻译评价类型
    transJudge (row) {
      return row.judge == '1' ? '好评' : row.judge =="2"?"差评":''
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form.id = undefined
    },
    // 确定按钮
    submit () {
      console.log(this.form)
      if (!this.form.id) {
        let userid = localStorage.getItem('userid');
        if(!this.form.content){
          return this.$message.error('请输入求助内容');
        }
        if(!this.form.address){
          return this.$message.error('请输入地址');
        }
        if(!this.form.phone){
          return this.$message.error('请输入联系方式');
        }
        this.form.userid = userid
        infoAdd(this.form).then(res => {
         if(res.code == '200'){
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
         }else{
          this.$message.error('服务异常');
         }

        })
      } else {
        updateInfo(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('修改成功')
          debugger
          this.handleQuery()
        })
      }
    },
        // 查看
        handleJudge (row) {
          debugger
      this.judgeOpen = true
      this.form.id = row.id
      this.form.help_userid = row.help_userid

    },
       // 确定按钮
       judgeSubmit () {
      console.log(this.form)
      if(this.judge){
        this.form.judge = '1'
      }else{
        this.form.judge = '2'
      }
      if(!this.form.judge_content){
       return this.$message.error('请添加评价')
      }
      judge(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('评价成功')
          this.judgeOpen = false
          this.handleQuery()
        })
      
    },
    // 查看
    handleView (row) {
      debugger
      this.open = true
      this.form = Object.assign({},row)
      this.disableFun(true)

    },
    // 修改按钮
    handleUpdate (row) {
      this.handleView(row)
      this.disableFun(false)
    },
    /**
     * @desc 禁用逻辑
     * @param {Blean}
    */
    disableFun (Blean) {
      this.disabled = Blean
    },
    // 查询按钮
    handleQuery () {
      
      let params= {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
        state:this.queryParams.state,
        judge:this.queryParams.judge,
      }
      tongji(params).then(res => {
        debugger 
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    },
    // 删除按钮
    handleDelete (id) {
      let obj = { id: id }
      deleteInfo(obj).then(res => {
        this.$message.success('删除成功')
        this.handleQuery()
      })
    },
    //  上一页面
    preClick(e){
      debugger
      this.pageIndex = e;
      if(pageIndex<=1){return}
      this.handleQuery()
    },
    // 下一页
    preClick(){
      let pageIndex = this.pageIndex +1;
      
      if(pageIndex * this.pageSize >= this.total){
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let userid = localStorage.getItem('userid')
      let params = {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
        userid:userid,
        flag:'my'
      }
      infoList(params).then(res => {
        debugger
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.gap{
  margin: 30px 10px;
}
</style>



// WEBPACK FOOTER //
// src/infoManage/tongji.vue